import type { NavState } from "@/lib/nav-state";

/**
 * One /api/nav-state request per page load, shared by the site navbar and the Companion frame
 * (the app view can mount both during hydration). Browser only. A failed read resolves to null
 * and is not cached, so a later mount can try again.
 */
let request: Promise<NavState | null> | null = null;

export function fetchNavStateOnce(): Promise<NavState | null> {
  request ??= fetch("/api/nav-state")
    .then((response) => (response.ok ? (response.json() as Promise<NavState>) : null))
    .catch(() => null)
    .then((state) => {
      if (!state) request = null;
      return state;
    });
  return request;
}

/** Tests only. */
export function resetNavStateRequestForTests() {
  request = null;
}
